import { render, staticRenderFns } from "./RTable.vue?vue&type=template&id=6f1f8f8e&scoped=true&"
import script from "./RTable.vue?vue&type=script&lang=js&"
export * from "./RTable.vue?vue&type=script&lang=js&"
import style0 from "./RTable.vue?vue&type=style&index=0&id=6f1f8f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f8f8e",
  null
  
)

export default component.exports